import React, { useState } from 'react';
import { BalanceCardsSection } from '../../components/domain-sections/BalanceCardsSection';
import type { BalanceCardItem } from '../../components/domain-sections/BalanceCardsSection';

const CUSTOMER_BALANCE_DATA = [
  {
    id: 'pending',
    label: 'Pending',
    totalBalance: '$103,679.14',
    balances: [
      { currency: 'USD', amount: 46077.55, formatted: '$46,077.55' },
      { currency: 'GBP', amount: 23653.14, formatted: '£23,653.14' },
      { currency: 'EUR', amount: 18431.02, formatted: '€18,431.02' },
      { currency: 'USDC', amount: 5119.73, formatted: '5,119.73' }
    ],
    status: 'pending',
    bgColor: 'bg-primary-light',
    textColor: 'text-foreground'
  },
  {
    id: 'operations',
    label: 'Operations',
    totalBalance: '$519,974.00',
    balances: [
      { currency: 'USD', amount: 260358.60, formatted: '$260,358.60' },
      { currency: 'GBP', amount: 108625.51, formatted: '£108,625.51' },
      { currency: 'EUR', amount: 76178.93, formatted: '€76,178.93' },
      { currency: 'USDC', amount: 28234.42, formatted: '28,234.42' }
    ],
    status: 'operations',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-950'
  },
  {
    id: 'marketing',
    label: 'Marketing',
    totalBalance: '$49,625.00',
    balances: [
      { currency: 'GBP', amount: 37218.75, formatted: '£37,218.75' },
      { currency: 'EUR', amount: 11406.25, formatted: '€11,406.25' }
    ],
    status: 'marketing',
    bgColor: 'bg-muted',
    textColor: 'text-foreground'
  }
];

export const BalanceSection = React.memo(() => {
  const [balances, setBalances] = useState<BalanceCardItem[]>(CUSTOMER_BALANCE_DATA);

  const handleBalanceAction = (_action: string, _balanceId: string) => {
    // Handle balance actions
  };

  const handleAddBalance = () => {
    const newBalance: BalanceCardItem = {
      id: `new_balance_${Date.now()}`,
      label: 'New Balance',
      totalBalance: '$0.00',
      balances: [
        { currency: 'USD', amount: 0, formatted: '$0.00' },
        { currency: 'EUR', amount: 0, formatted: '€0.00' }
      ],
      status: 'new_balance',
      bgColor: 'bg-green-50',
      textColor: 'text-green-900'
    };
    
    setBalances(prev => [...prev, newBalance]);
  };

  return (
    <BalanceCardsSection
      balances={balances}
      onBalanceAction={handleBalanceAction}
      onAddBalance={handleAddBalance}
      showAddCard={true}
    />
  );
});

BalanceSection.displayName = 'BalanceSection';
